import { ClientMappingApiType, ClientMappingFieldWithPrefix, MERGE_ASANA_REMOTE_FIELDS } from "@avenueops/shared-types";
import { NotificationType } from "@prisma/client";
import { trpc2 } from "utils/trpc";

export type MergeRemoteField = { display_name: string; id: string };

export function augmentMappings(
  type: ClientMappingApiType,
  fullFieldName: string,
  selectedIntegrationId: string,
  recipientValue: string
): ClientMappingFieldWithPrefix[] | undefined {
  switch (type) {
    case NotificationType.ASANA:
      return augmentAsanaMappings(selectedIntegrationId, fullFieldName);
    case NotificationType.NOTION:
      return augmentNotionMappings(selectedIntegrationId, recipientValue);
  }
  return undefined;
}

function augmentAsanaMappings(selectedIntegrationId: string, fullFieldName: string): ClientMappingFieldWithPrefix[] | undefined {
  const { data } = trpc2.v2.merge.fetchAsanaRemoteFields.useQuery(
    { integrationId: selectedIntegrationId },
    { enabled: fullFieldName.includes(MERGE_ASANA_REMOTE_FIELDS) }
  );

  return data?.map((option: MergeRemoteField) => {
    return { field: { name: option.display_name, type: "VALUE", value: "" }, prefix: "remote_fields" };
  });
}

function augmentNotionMappings(selectedIntegrationId: string, recipientValue: string): ClientMappingFieldWithPrefix[] | undefined {
  const { data } = trpc2.v2.notion.getNotionDatabase.useQuery({
    integrationId: selectedIntegrationId,
    databaseId: recipientValue,
  });

  return data?.map((option) => {
    return { field: { name: option.name, type: "VALUE", value: "" }, prefix: "properties" };
  });
}
